import PropTypes from 'prop-types';
import { Platform } from 'react-native';
// import styles from './styles/styles';
// import { getResponsiveStyle } from '../../utils/appUtils';
import Header from './Header';
import React, { Component } from 'react';
// import { renderComponent } from 'recompose';
import CustomBootbox from '../../components/CustomBootbox';
import { ALL_CONSTANTS } from '../../constants/displayConstants';
const x_stu_O = 'AIzaSyCcFtl0ekH3uaG2eF6YklOoPPPR2LWr-6o';
var flag = '';

class BackgroundColorWidthLogo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      dropdownOpen: false,
      userIp: '',
      userAddress: '',
    };
  }

  componentWillReceiveProps(newprops) {
    const location = sessionStorage.getItem('location');
    const userIp = sessionStorage.getItem('userIp');

    this.setState({
      userAddress: location,
      userIp,
    });
  }

  handleLocationError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        this.setState({
          userIdle: true,
          bootboxtext:
            '\n\nLooks like your location permission is blocked for entered website. Please provide location access to proceed further. Here’s how you can navigate:\n\nIf you are using laptop/ desktop:\n\nChrome Settings / More Settings by clicking on right top browser settings menu >> Privacy & Security >> Site Settings >> Permissions >> Location >> Select Enable/ Allow for https://service.icicibank.com\n\nIf you are using mobile device:\n\nSettings >> Site Settings/ App Settings >> Permissions >> Location >> Chrome >> Enable/ allow for https://service.icicibank.com',
          headerText: 'Your Location access is blocked',
          openmodel: true,
        });
        console.log('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        console.log('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        console.log('The request to get user location timed out.');
        break;
      case error.UNKNOWN_ERROR:
        console.log('An unknown error occurred.');
        break;
    }
  };

  reverseGeoCode = () => {
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.state.latitude},${this.state.longitude}&sensor=true&key=${x_stu_O}`
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          userAddress: data.plus_code.compound_code.substring(8),
        });
        sessionStorage.setItem(
          'location',
          data.plus_code.compound_code.substring(8)
        );
      })
      .catch((error) => error);
  };

  fetchIpLocation() {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          userIp: data.ip,
        });
        sessionStorage.setItem('userIp', data.ip);
      })
      .catch((error) => this.setState({ userIp: 0 }));
  }

  getCoordinates = (position) => {
    this.setState({
      longitude: position.coords.longitude,
      latitude: position.coords.latitude,
    });
    sessionStorage.setItem('longitude', position.coords.longitude)
    sessionStorage.setItem('latitude', position.coords.latitude)
    this.reverseGeoCode();
  };

  onGoBack(data) {
    this.props.onGoBack(data);
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };
  refresh() {
    var clear = [
      'time',
      'product_name',
      'payment_gateway',
      'stopwatch',
      'credit_opted',
      'flow',
      'easyPay',
      'token',
    ];

    clear.map((item) => {
      sessionStorage.removeItem(item);
    });
  }
  closebootbox = () => {
    if (this.state.userIdle) {
      this.refresh();
      window.removeEventListener('keydown', this.handleKeyPress);
      if (Platform.OS == 'web') {
        const pathName = window.location.pathname;
        const domainName = window.location.origin;

        const path = [
          ALL_CONSTANTS.PROFILE_PATH,
          ALL_CONSTANTS.ACCOUNT_PATH,
          ALL_CONSTANTS.CREDIT_CARD_PATH,
          ALL_CONSTANTS.LOAN_PATH,
          ALL_CONSTANTS.DEPOSITS_PATH,
          ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH,
          ALL_CONSTANTS.FOREX_PATH,
          ALL_CONSTANTS.DUE_PATH,
        ];

        let updatedPath = pathName.substr(0, pathName.lastIndexOf('/'));
        if (path.includes(updatedPath)) {
          window.location.href = `${domainName}${updatedPath}`;
          return;
        } else {
          window.location.href = `${domainName}/servicing/index.html`;
        }
      } else {
        window.location.href = `${domainName}/servicing/index.html`;
        //props.navigation.navigate('HomePage');
      }
      // Linking.openURL(window.location.origin);
    } else {
      this.setState({
        openmodel: false,
        modalopenhide: false,
      });
    }
  };
  render() {
    const {
      children,
      measure,
      heading,
      time,
      user,
      showip,
      goBack,
      identification,
      component_name,
      notrequired,
      isSearch,
      componentSubHeading,
      showHide,
      isPan,
      onPressHideShow,
      disabled,
      headerFlag,
      noSearch,
    } = this.props;
    let TextNewMssgshow =
      this.props.TextNewMssgshow !== undefined
        ? this.props.TextNewMssgshow
        : true;
    return (
      <Header
        {...this.props}
        showip={showip}
        goBack={goBack}
        measure={measure}
        isSearch={isSearch}
        noSearch={noSearch}
        disabled={disabled}
        blurValue={this.state.value === 1 ? true : false}
        backBlur={(data) => this.props.handlePick(data)}
        onGoBack={(data) => this.onGoBack(data)}
        dropDownOpen={this.state.dropdownOpen}
        toggle={() => this.toggle}
        userIp={this.state.userIp}
        userAddress={this.state.userAddress}
        headerFlag={headerFlag}
        valueBlur={this.props.valueBlur}
      >
        <CustomBootbox
          {...this.props}
          measure={measure}
          bootboxtext={this.state.bootboxtext}
          headerText={this.state.headerText}
          bootboxmodal={this.state.openmodel}
          closebootbox={this.closebootbox}
          hideBlackout
        />
        {children}
      </Header>
    );
  }
}

BackgroundColorWidthLogo.propTypes = {
  TextNewMssgshow: PropTypes.any,
  children: PropTypes.any,
  componentSubHeading: PropTypes.any,
  component_name: PropTypes.any,
  disabled: PropTypes.any,
  goBack: PropTypes.any,
  handlePick: PropTypes.func,
  headerFlag: PropTypes.any,
  heading: PropTypes.any,
  identification: PropTypes.any,
  isPan: PropTypes.any,
  isSearch: PropTypes.any,
  measure: PropTypes.any,
  noSearch: PropTypes.any,
  notrequired: PropTypes.any,
  onGoBack: PropTypes.func,
  onPressHideShow: PropTypes.any,
  showHide: PropTypes.any,
  showip: PropTypes.any,
  time: PropTypes.any,
  user: PropTypes.any,
  valueBlur: PropTypes.any,
};

export default BackgroundColorWidthLogo;
